import { Component, Type } from '@angular/core';
import { PluginTemplate } from '../templates/plugin/plugin.component';

export class Plugin {

    /**
     * The name.
     */
    public name: string;

    /**
     * The component.
     */
    public component: Type<Component>;

    /**
     * The template to use.
     */
    public template: any = PluginTemplate;

    /**
     * The order of the plugin in the slot.
     */
    public order: number;

    /**
     * The input bindings.
     */
    public inputs: Object;

    /**
     * The output bindings.
     */
    public outputs: Object;

    public options: { [key: string]: any };

    /**
     * The modal's data.
     */
    public data: { [key: string]: any };

    /**
     * @param {string} name
     * @param {Type<Component>} component
     * @param order
     * @param data
     * @param options
     * @param template
     */
    constructor(name: string, component: Type<Component>, order: number, data: { [key: string]: any }, options: { [key: string]: any }, template?: any) {
        this.name      = name;
        this.component = component;
        this.order     = order;
        this.data      = data;
        this.options   = options;

        if (template) {
            this.template = template;
        }
    }

    /**
     * Register the input bindings.
     *
     * @param {{}} inputs
     */
    public input(inputs: { [key: string]: any } = null) {
        this.inputs = inputs;
        return this;
    }

    /**
     * Register the output bindings.
     *
     * @param {{}} outputs
     */
    public output(outputs: { [key: string]: any } = null) {
        this.outputs = outputs;
        return this;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/classes/plugin.ts